import { AbstractPersistentFilter } from './AbstractPersistentFilter.mjs'

export class NoOpUrlFilter extends AbstractPersistentFilter {
  static TYPE = 'noop'
  constructor(opts = {}) {
    super(NoOpUrlFilter.TYPE, { value: 'noop' })
  }
  matches(url) {
    return false
  }

  explain(url) {
    return null
  }

  get simpleLabel() {
    return ``
  }
}
